<template>
  <user-form
    mode="Edit"
    @save="saveUser()"
    :user="user"
    :roles="roles"
    :saveLoading="saveLoading"
  ></user-form>
</template>

<script>
import { mapGetters } from 'vuex';
import UserForm from '../../components/UserForm.vue';

export default {
  name: 'edit-user-view',
  components: { UserForm },
  props: {
    editUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      saveLoading: false,
      user: {
        id: null,
        givenName: '',
        familyName: '',
        email: '',
        communicationLanguage: '',
        role: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      roles: 'users/roles',
    }),
  },
  async created() {
    if (this.editUser) {
      this.user.id = this.editUser.id;
      this.user.email = this.editUser.email;
      this.user.givenName = this.editUser.givenName;
      this.user.familyName = this.editUser.familyName;
      this.user.communicationLanguage = this.editUser.communicationLanguage;
      this.editUser.roles.forEach((role) => {
        this.user.role = role.name;
      });
    } else {
      await this.$router.push('/users/');
    }
  },
  methods: {
    async saveUser() {
      try {
        this.saveLoading = true;
        const payload = this.user;
        const result = await this.$store.dispatch('users/updateUser', payload);

        if (!result.errorCode) {
          await this.$router.push('/users/');
        }
      } finally {
        this.saveLoading = false;
      }
    },
  },
};
</script>
